import { takeLatest, put, call, fork } from 'redux-saga/effects';
import callApi from 'utils/api';
import * as actionTypes from './constants';

import {
  getIsDecimalSuccess,
  getIsDecimalFailure,
} from './service-center-toggle-actions';

export function* doGetIsDecimal(action) {
  try {
    const options = {
      endpoint: `/info/decimals/${action.payload}`,
      options: {
        errorMessage: 'Could not fetch show decimals for active service center ',
        retryAction: action,
      },
    };
    const results = yield call(callApi, options);
    yield put(getIsDecimalSuccess(results));
  } catch (err) {
    yield put(getIsDecimalFailure(err));
  }
}

function* watchIsDecimal() {
  yield takeLatest(actionTypes.GET_IS_DECIMAL_REQUEST, doGetIsDecimal);
}

export default [
  fork(watchIsDecimal),
];
